import { API_ROUTES, HealthResponseSchema, type HealthResponse } from '@aibi/contracts';
import type { AppError, Result } from '@aibi/shared';
import { requestJson, type FetchFn } from './http-client';

export interface HealthApi {
  getHealth(signal?: AbortSignal): Promise<Result<HealthResponse, AppError>>;
}

export interface HealthApiOptions {
  readonly baseUrl: string;
  readonly fetch: FetchFn;
}

export function createHealthApi({ baseUrl, fetch }: HealthApiOptions): HealthApi {
  return {
    getHealth: (signal) =>
      requestJson(
        fetch,
        `${baseUrl}${API_ROUTES.health}`,
        HealthResponseSchema,
        signal ? { signal } : {},
      ),
  };
}
